/* BD Maschine zuerst 24.09.2026
 * Alt: Gerätekarte und Anfrage waren nicht gekoppelt.
 * Neu: Produkt-Handle, Systemwahl und Finanzierungsanliegen werden gemeinsam vorbelegt.
 * Grund: Preise-Landingpage bleibt ein bestehendes B2-Produktformular, ohne eigenen Versand. */
(function () {
  'use strict';
  var handles = {
    'FlexClean Backpack': 'flexclean-backpack-100-300-watt-reinigungslaser-mopa',
    'SpectraClean Elite': 'mobiles-handgefuhrte-laser-reinigungssystem-spectraclean-elite',
    'ProBeam 500': 'probeam-500-laserreinigungsmaschine-500watt',
    'BDCW 2000-3000W': 'cw-reinigungslaser-2000w-leistungsstarke-laserreinigung-fur-industrielle-anwendungen',
    'CW 3in1': 'beam-deals-cw-serie-3in1-laserschweissgerat-laserreiniger-laserschneidgerat-profi-laser-fur-metallbearbeitung'
  };
  document.querySelectorAll('.bd62--prices').forEach(function (root) {
    var form = root.querySelector('#bd62-anwendung-form');
    if (!form) return;
    var product = form.querySelector('[name="contact[Produkt]"]');
    var system = form.querySelector('[data-bd62-system]');
    var message = form.querySelector('[name="contact[body]"]');
    var name = form.querySelector('[name="contact[Name]"]');
    var person = form.querySelector('[name="contact[Ansprechpartner]"]');
    var status = form.querySelector('[data-bd-price-selection]');
    function syncProduct() {
      if (product) product.value = system ? (handles[system.value] || '') : '';
      if (message && message.dataset.bdPricePrefill && message.value === message.dataset.bdPricePrefill) {
        var topic = message.dataset.bdPriceTopic || '';
        message.value = product && product.value ? (topic ? 'Konditionen für ' + system.value + ': ' + topic : 'Bitte um ein Angebot für ' + system.value + '.') : '';
        message.dataset.bdPricePrefill = message.value;
      }
      if (status) status.textContent = product && product.value && system ? 'Ihre Anfrage: ' + system.options[system.selectedIndex].textContent : 'Wir beraten Sie zur passenden Anlage.';
    }
    function syncName() { if (person && name) person.value = name.value; }
    if (system) system.addEventListener('change', syncProduct);
    if (name) name.addEventListener('input', syncName);
    form.addEventListener('submit', function () { syncName(); syncProduct(); }, true);
    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-bd-price-inquiry]');
      if (!link || !root.contains(link)) return;
      if (system) system.value = link.dataset.bdPriceSystem || '';
      syncProduct();
      if (product && handles[link.dataset.bdPriceSystem] === link.dataset.bdPriceProduct) product.value = link.dataset.bdPriceProduct;
      var topic = link.dataset.bdPriceTopic;
      var text = topic ? 'Konditionen für ' + link.dataset.bdPriceName + ': ' + topic : 'Bitte um ein Angebot für ' + link.dataset.bdPriceName + '.';
      if (message) {
        var previous = message.dataset.bdPricePrefill || '';
        message.dataset.bdPriceTopic = topic || '';
        if (!message.value.trim() || message.value === previous) message.value = text;
        else if (topic && message.value.indexOf(text) === -1) message.value += '\n' + text;
        message.dataset.bdPricePrefill = message.value === text ? text : previous;
      }
      root.querySelectorAll('.bd-price-finance details[open]').forEach(function (details) { details.open = false; });
      var heading = root.querySelector('#anfrage h2');
      if (heading) { heading.setAttribute('tabindex', '-1'); setTimeout(function () { heading.focus({preventScroll: true}); }, 0); }
    });
    root.querySelectorAll('.bd-price-finance details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        root.querySelectorAll('.bd-price-finance details[open]').forEach(function (other) { if (other !== details) other.open = false; });
      });
      details.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); }
      });
    });
    syncName(); syncProduct();
  });
})();
